import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-check-box',
  templateUrl: './ab-check-box.component.html',
  styleUrls: ['./ab-check-box.component.scss']
})
export class AbCheckBoxComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
